import React, { FunctionComponent } from 'react';

import {
  customerCareNumber,
  format1300Number,
} from 'scenes/common/helpers/contacts';
import { ApiData, ApiState } from 'scenes/common/types';
import ErrorModal from 'components/ErrorModal';

import CardPayment from '../components/CardPayment';

const getHeader = (apiLoadingState: ApiState | undefined): string =>
  apiLoadingState === ApiState.PaymentError
    ? 'Sorry, we’re having trouble processing your payment'
    : "Something's gone wrong";

const getContent = (apiLoadingState: ApiState | undefined): string =>
  apiLoadingState === ApiState.PaymentError
    ? `Please try again or call us on ${format1300Number(
        customerCareNumber()
      )} to finalise your payment. Remember to take a note of your policy number.`
    : 'Please try again';

type QuoteErrorModalProps = {
  apiResponse: ApiData<unknown>[];
  onClear: () => void;
  ImageComponent: FunctionComponent;
};

export const QuoteErrorModal: FunctionComponent<QuoteErrorModalProps> = ({
  apiResponse,
  onClear,
  ImageComponent,
}) => {
  let currentApiState = ApiState.Error;
  const isOpen = apiResponse.some((d) => {
    currentApiState = d.state;
    return d.state === ApiState.Error || d.state === ApiState.PaymentError;
  });

  return (
    <ErrorModal
      isOpen={isOpen}
      header={getHeader(currentApiState)}
      content={getContent(currentApiState)}
      ImageComponent={() =>
        currentApiState === ApiState.PaymentError ? (
          <CardPayment />
        ) : (
          <ImageComponent />
        )
      }
      onClose={onClear}
    />
  );
};

export default QuoteErrorModal;
